import { TableBody } from '@material-ui/core';

import { NotificationTableRow } from '@/components/modules/Notifications/components/NotificationTableRow';
import { NotificationsTableProps } from '@/components/modules/Notifications/types/NotificationsProps';

export const Body = ({ notifications, loan, tableProps }: NotificationsTableProps) => {
  return (
    <>
      <TableBody>
        {notifications.map((notification, index) => (
          <NotificationTableRow
            key={`${index}-${notification.id}`}
            notification={notification}
            loan={loan}
            tableProps={tableProps}
          />
        ))}
      </TableBody>
    </>
  );
};
